import { Button } from '@common/ui/buttons/Button';

import { SuperlikeOverlay } from '../SuperlikeOverlay';
import { formatResetIn } from '../utils';
import styles from './SuperlikeLimitSheet.module.scss';

export type SuperlikeLimitSheetProps = {
  /** When new superlikes come; null when the server does not say. */
  resetTime: string | null;
  isPremium: boolean;
  onPremium: () => void;
  onClose: () => void;
};

/** No superlikes left (board 2.2). */
export const SuperlikeLimitSheet = ({
  resetTime,
  isPremium,
  onPremium,
  onClose,
}: SuperlikeLimitSheetProps) => (
  <SuperlikeOverlay
    testId="superlike-limit-sheet"
    label="Суперлайки закончились"
    icon="/icons/3d-icons/sand-clock.png"
    onClose={onClose}
    buttons={[
      ...(isPremium
        ? []
        : [
            <Button
              testId="superlike-limit-sheet-premium-button"
              variant="premiumGradient"
              size={1000}
              onClick={onPremium}
            >
              Подключить Premium
            </Button>,
          ]),
      <Button
        testId="superlike-limit-sheet-close-button"
        variant="actionSecondary"
        size={1000}
        onClick={onClose}
      >
        Понятно
      </Button>,
    ]}
  >
    <div className={styles.text}>
      <h2 className={styles.title}>Суперлайки закончились</h2>
      {(resetTime || !isPremium) && (
        <p
          className={styles.description}
          data-test-id="superlike-limit-sheet-description"
        >
          {resetTime && (
            <span data-test-id="superlike-limit-sheet-reset">
              Новые появятся через {formatResetIn(resetTime)}.
            </span>
          )}
          {resetTime && !isPremium && <br />}
          {!isPremium && (
            <span data-test-id="superlike-limit-sheet-premium-note">
              В Premium суперлайков больше
            </span>
          )}
        </p>
      )}
    </div>
  </SuperlikeOverlay>
);
